module.exports = __webpack_public_path__ + "img/logo.1879dacb.png";